module.exports = __webpack_public_path__ + "assets/113ee46c27c90e442621b534f74be297.mp3";